module.exports = "/templates/userprofile.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/userprofile.html
// module id = 483
// module chunks = 0